export const MAX_GROUP_PATIENTS = 3;

export const DEFAULT_VALUES = {
    gender: "",
    salutation: "",
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    age: "",
    dob: null,
    visitDate: new Date(),
    pincode: "",
    locationId: "",
    locationName: "",
    orgId: "",
    addressLine: "",
    addressLine1: "",
    addressLine2: "",
    flatNo: "",
    buildingName: "",
    locality: "",
    landmark: "",
    addressEditing: false,
    tests: [],
    selectedSlot: null,
};

export const STEPS = [
    { id: "collect", label: "Type" },
    { id: "pincodeGate", label: "Pincode" },
    { id: "patient", label: "Patient" },
    { id: "location", label: "Location" },
    { id: "tests", label: "Tests" },
    { id: "slot", label: "Slot" },
    { id: "summary", label: "Summary" },
];

export const getStepFields = (stepId, mode) => {
    switch (stepId) {
        case "pincodeGate":
            return ["pincode"];
        case "patient":
            return ["gender", "salutation", "firstName", "lastName", "mobile", "email", "age", "dob"];
        case "location":
            return mode === "clinic"
                ? ["locationId", "addressLine1", "addressLine", "addressEditing"]
                : ["pincode", "locationId", "flatNo", "buildingName", "locality", "landmark", "addressLine"];
        case "tests":
            return ["tests"];
        case "slot":
            return ["visitDate", "selectedSlot"];
        default:
            return [];
    }
};
